/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon24Regular = forwardRef('NetCloudIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.719 8.618a6.301 6.301 0 0 1 11.925-1.766l.156-.002a6.45 6.45 0 0 1 0 12.9H6.3A5.7 5.7 0 0 1 4.719 8.618ZM10.95 4.75a4.8 4.8 0 0 0-4.791 4.505.75.75 0 0 1-.592.688 4.202 4.202 0 0 0 .791 8.307H16.8a4.95 4.95 0 1 0-.556-9.87.75.75 0 0 1-.787-.486A4.802 4.802 0 0 0 10.95 4.75Z" })));
});
